import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import set from 'lodash/set';
import get from 'lodash/get';

import FormContext from 'src/presentation/contexts/FormContext';
import { Checkbox } from 'src/presentation/components/agent_desktop_components';

const FieldToggle = (props: any) => {
  const { workingState, updateState, errors, resetError } = useContext(FormContext);
  const { attr, children, doNotExpandContent, label, onChange, dataAid } = props;
  const [isEnabled, setIsEnabled] = useState(!!get(workingState, attr));

  const toggleIsEnabled = () => {
    const newEnabledVal = !isEnabled;
    setIsEnabled(newEnabledVal);
    resetError({ attr, errors });
    updateState(set({}, attr, onChange(newEnabledVal, get(workingState, attr))));
  };

  const onClick = evt => {
    evt.preventDefault();
    evt.stopPropagation();
    toggleIsEnabled();
  };

  return (
    <ToggleWrapper doNotExpandContent={doNotExpandContent}>
      <ClickHandler onClick={onClick} data-aid={dataAid}>
        <StyledCheckbox checked={isEnabled} /> {label}
      </ClickHandler>
      {children(isEnabled)}
    </ToggleWrapper>
  );
};

// The Checkbox component does not behave as expected, so fuck it.
const StyledCheckbox = styled(Checkbox)`
  margin-right: 4px;
  pointer-events: none;
`;

const ClickHandler = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  margin-bottom: 8px;
`;

const ToggleWrapper = styled.div`
  ${p => (p.doNotExpandContent ? 'width: 100%; min-width: 0' : 'flex: 1 1 auto')};
`;

export default FieldToggle;
